import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  schema as schema_studium,
} from "Apis/person-studienbereich-api";
import {
  beforeSaveAusbildung,
  beforeSaveWerdegang,
  schema as schema_abschluss,
} from "Apis/person-werdegang-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  buildSubSchemas,
} from "App/shk-form-tab";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
  getModusFromAntrag,
} from "App/constants";


// Definition der Sub-Panels
export const subpanels = [
  {
    key: "ausbildung",
    header: "Ausbildung",
    endpoint: "/api/shkperson/werdegang",
    beforeSave: beforeSaveAusbildung,
  },
  {
    key: "werdegang",
    header: "Hochschulabschluss",
    endpoint: "/api/shkperson/werdegang",
    beforeSave: beforeSaveWerdegang,
  },
  {
    key: "studienbereich",
    header: "Studium",
    schema: schema_studium,
    endpoint: "/api/shkperson/studienbereich",
  },

];

buildSubSchemas(_.filter(subpanels, sp => ["ausbildung", "werdegang"].indexOf(sp.key) >= 0), schema_abschluss);

const injects = _.flatMap(subpanels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

_.map(subpanels, panel => _.assign(panel, { route: "/person/studium", label: "Studentische / Wissenschaftliche Daten" }));

@store(...injects, "flag_antragstellermodus")
export default class PersonStudienTab extends Component {
  constructor() {
    super();
    this.state = { filteredSubpanels: null, istTarifvertrag: false };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus ||
      !_.isEqual(prevProps.antrag, this.props.antrag)) {
      this.initSubpanels(this.props);
    }
  }

  componentDidMount() {
    this.initSubpanels();
  }

  initSubpanels(nextProps = this.props) {
    const { flag_antragstellermodus, antrag } = nextProps;
    const modus = ANTRAGSTELLERMODUS[flag_antragstellermodus || (antrag && getModusFromAntrag(antrag))];
    const lehrvertrag = modus?.value === ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = modus?.value === ASTMODUSKEY.Tarif;
    this.setState({
      istTarifvertrag: tarifvertrag,
      filteredSubpanels:
        subpanels.filter(x => {
          return !((lehrvertrag || tarifvertrag) && x.key === "studienbereich") // PBP-2283 kein Studium Block für Tarif
            && (tarifvertrag || x.key != "ausbildung");
        }).map(x => {
          if (x.key == "werdegang") {
            if (lehrvertrag) {
              x.label = "Qualifikation";
            } else if (tarifvertrag) {
              x.label = "Akademische Ausbildung"; // Das hier muss ggf. anders
            }
            const ha = x.schema.table.find(x => x.field == "pwg_pfaid");
            if (ha) {
              if (lehrvertrag) {
                ha.display = "Höchster Hochschulabschluss";
              } else {
                ha.display = "Hochschulabschluss";
              }
            }
          }
          return x;
        }),
    });
  }

  render() {
    const { filteredSubpanels } = this.state;
    return <div>
      {filteredSubpanels &&
        <SHKFormTab
          subpanels={filteredSubpanels}
          injects={selectInjects(this.props)} />
      }
    </div>;
  }
}
